export const DEFAULT_BOOKING = 'Z53DVDE';
export const CANCELLED_BOOKING = 'Z53DVDE-CANCELED';
export const STARTED_BOOKING = 'Z53DVDE-STARTED';
export const WAITLIST_BOOKING = 'Z53DVDE-WAITLIST';
export const NO_FEE_BOOKING = 'Z53DVDE-NO-FEE';
export const PER_RESERVATION_FEE_BOOKING = 'Z53DVDE-PER-RES-FEE';
export const BOOKING_WITH_EMPTY_EMAIL = 'Z53DVDE-EMPTY-EMAIL';
export const BOOKING_WITH_INVALID_EMAIL = 'Z53DVDE-INVALID-EMAIL';
export const BOOKING_WITH_RES_DETAILS = 'Z53DVDE-RES-DETAILS';
export const NO_CHECKLESS_PAYMENTS_BOOKING = 'Z53DVDE-NO-CHECKLESS-PAYMENTS';
export const USHG_BOOKING = 'Z53DVDE-USHG';
export const UNENROLLED_BOOKING = 'Z53DVDE-UNENROLLED';
export const INTEGRATION_TEST_BOOKING = 'Z53DVDE-BOOKING-WITH-FEE';
export const INTEGRATION_TEST_CANCELLED_BOOKING =
  'Z53DVDE-CANCELED-BOOKING-WITH-FEE';
export const SPECIAL_REQUEST_STEP_1 = 'RM6617-NEW-SPECIAL-REQUEST-STEP-1';
export const SPECIAL_REQUEST_STEP_2 = 'RM6617-NEW-SPECIAL-REQUEST-STEP-2';
export const UNENROLLMENT_INITIAL_DATA = 'RM6269-UNENROLLMENT-STEP1';
export const UNENROLLMENT_FINAL_DATA = 'RM6269-UNENROLLMENT-STEP2';
export const UNENROLLMENT_CUSTOM_GRATUITY_INITIAL_DATA =
  'RM6272-UNENROLLMENT-STEP1';
export const UNENROLLMENT_CUSTOM_GRATUITY_FINAL_DATA =
  'RM6272-UNENROLLMENT-STEP2';
export const UNENROLLMENT_UPDATE_GRATUITY_INITIAL_DATA =
  'RM6274-UNENROLLMENT-STEP1';
export const UNENROLLMENT_UPDATE_GRATUITY_FINAL_DATA =
  'RM6274-UNENROLLMENT-STEP2';
export const REDIRECT_TO_LIVE_CHECK = 'REDIRECT_TO_LIVE_CHECK';
